<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
  -->

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import ClientProfile from "@/core/js/model/Profile/ClientProfile";

export default {
	name: "BaseClientDetailsTab",
	extends: BaseComponent,

	props: {
		clientProfile: {ClientProfile, required: true},
	},
}
</script>

<style lang="scss">

</style>
